import React from "react";

interface Props {
  title: string;
  subTitle: string;
  description?: string;
}

function DescriptionBox({ title, subTitle, description }: Props) {
  return (
    <div className="flex flex-col">
      <span className="page-breadcrumb">{title}</span>
      <h1 className="card-title mt-2.5">{subTitle}</h1>
      {description && <p className="card-subtitle m-0 mt-1">{description}</p>}
    </div>
  );
}

export default DescriptionBox;
